import { VisitState } from '@/features/visits/api/types/visits';

export const visitFlowOptions = (state: VisitState) => {
  const quickActions = {
    created: {
      label: 'Created',
      value: VisitState.CREATED,
      color: 'rgba(6, 70, 153, 1)',
    },
    cancelled: {
      label: 'Cancelled',
      value: VisitState.CANCELLED,
      color: '#a53531',
    },
    started: {
      label: 'Started',
      value: VisitState.STARTED,
      color: '#1b774d',
    },
    finished: {
      label: 'Finished',
      value: VisitState.FINISHED,
      color: '#506176',
    },
    rejected: {
      label: 'Rejected',
      value: VisitState.REJECTED,
      color: '#a53531',
    },
  };

  const quickActionsMap = {
    created: [quickActions.cancelled],
    started: [quickActions.finished],
    cancelled: [],
    finished: [],
    rejected: [],
  };

  return quickActionsMap[state] || [];
};
